enum DialogTypes {
  DONT_SHOW_IN_LEADER_DIALOG,
  STORAGE_LIMITATION_REACHED_DIALOG,
  FILE_REMOVING_DIALOG,
  FILE_RENAME_DIALOG,
  FILE_SIZE_NOT_SUPPORTED_DIALOG,
}

export default DialogTypes;
